import { useState, useEffect, useRef } from "react";
import { eventBus } from "../../eventBus";
import { formatTime } from "@/lib/utils";

const Timer = ({ isPaused }: { isPaused: boolean }) => {
    const [timer, setTimer] = useState<number>(() => {
        const storedTime = localStorage.getItem("timer");
        return storedTime ? parseInt(storedTime, 10) : 0;
    });

    const intervalRef = useRef<number | null>(null);

    useEffect(() => {
        const resetTimer = () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
            localStorage.setItem("timer", "0");
            setTimer(0);
        };

        eventBus.on("resetTimer", resetTimer);

        return () => {
            eventBus.off("resetTimer", resetTimer);
        };
    }, []);

    useEffect(() => {
        if (!isPaused) {
            if (intervalRef.current) clearInterval(intervalRef.current);
            intervalRef.current = window.setInterval(() => {
                setTimer((prev) => {
                    const updatedTime = prev + 1;
                    localStorage.setItem("timer", updatedTime.toString());
                    return updatedTime;
                });
            }, 1000);
        } else {
            if (intervalRef.current) clearInterval(intervalRef.current);
        }

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [isPaused]);

    return <div>{formatTime(timer)}</div>;
};

export default Timer;
